import { createContext, useContext, useEffect, useState } from "react";
import { api, API } from "@/lib/api";
import { fmtMoney } from "@/lib/format";
import { FOUNDER } from "@/config/landing";

const build = (st) => ({
  founderPrice: fmtMoney(st.founder_price),
  regularPrice: fmtMoney(st.regular_price),
  seats: st.seats,
  deliveryDate: st.delivery_date,
  calendlyUrl: st.calendly_url,
  contactEmail: st.contact_email,
  founderPaymentUrl: st.founder_payment_url || "",
  memberPaymentUrl: st.member_payment_url || "",
  liveMode: Boolean(st.live_mode),
  founder: { ...FOUNDER, photo: st.founder_photo_path ? `${API}/public/founder-photo?v=${encodeURIComponent(st.founder_photo_path)}` : null },
});

const DEFAULTS = build({ founder_price: 690, regular_price: 1200, seats: 10, delivery_date: "…", calendly_url: "#", contact_email: "", founder_photo_path: null });
const SiteContext = createContext(DEFAULTS);

export function SiteProvider({ children }) {
  const [site, setSite] = useState(DEFAULTS);
  useEffect(() => { api.get("/site-settings").then((r) => setSite(build(r.data))).catch(() => {}); }, []);
  return <SiteContext.Provider value={site}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);
